// path: frontend/src/pages/Login.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import img1 from "../assets/login/1.jpg";
import img2 from "../assets/login/2.jpg";
import img3 from "../assets/login/3.jpg";
import img4 from "../assets/login/4.jpg";

import logo from "../assets/logo.jpg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      toast.success("¡Bienvenido!");
      navigate("/dashboard");
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Collage 2x2 */}
        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-3 p-6">
          <div className="rounded-2xl overflow-hidden">
            <img src={img1} alt="" className="h-full w-full object-cover" />
          </div>

          <div className="rounded-2xl overflow-hidden">
            <img src={img2} alt="" className="h-full w-full object-cover" />
          </div>

          <div className="rounded-2xl overflow-hidden">
            <img src={img3} alt="" className="h-full w-full object-cover" />
          </div>

          <div className="rounded-2xl overflow-hidden">
            <img src={img4} alt="" className="h-full w-full object-cover" />
          </div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/45 to-cyan-500/8" />
        
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-slate-50">
        <Card
          className="w-full max-w-md shadow-lg border-slate-200"
          data-testid="login-card"
        >
          <CardHeader className="space-y-1">
            <div className="flex justify-center">
              <img
                src={logo}
                alt="Batas Médicas"
                className="h-30 w-30 mb-2 rounded-full object-cover ring-1 ring-slate-200"
              />
            </div>

            <div className="relative z-10 flex flex-col justify-center px-12">
              <h1
                className="text-3xl font-bold mb-4 text-center"
                style={{ fontFamily: "Outfit" }}
              >
                Batas Médicas App
              </h1>

              <div className="h-1 w-24 mx-auto rounded-full bg-cyan-400/80 mb-4" />

              
             
            </div>

            <CardTitle
              className="text-3xl font-bold text-center"
              style={{ fontFamily: "Outfit" }}
            >
              Iniciar Sesión
            </CardTitle>
            <CardDescription className="text-center">
              Ingresa tus credenciales para acceder
            </CardDescription>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-slate-50 border-slate-200 focus:ring-2 focus:ring-cyan-500/20 focus:border-cyan-500 h-11"
                  data-testid="login-email-input"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="bg-slate-50 border-slate-200 focus:ring-2 focus:ring-cyan-500/20 focus:border-cyan-500 h-11"
                  data-testid="login-password-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-medium shadow-md shadow-cyan-500/20 h-11"
                disabled={loading}
                data-testid="login-submit-button"
              >
                {loading ? (
                  "Iniciando..."
                ) : (
                  <>
                    <LogIn className="w-5 h-5 mr-2" />
                    Iniciar Sesión
                  </>
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
